import React from 'react';
import qs from 'query-string';
import { createForm } from 'rc-form';
import { Modal, Toast } from 'antd-mobile';
import Waiting from '../common/waiting';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { queryOrderDetailByOrderToken } from '../../service/api';
import connect from '../../store/connect';
import { SearchMatch } from '../../service/ActivityService';

export type OrderPayWaitingProps = {
    search: any;
} & Props & RouteComponentProps;
class OrderPayWaiting extends React.Component<OrderPayWaitingProps, State> {
    constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            waitingCount:10
        };
    }
    search: SearchMatch = qs.parse(this.props.location.search);
    waitingTimer?: number;
    componentDidMount() {
        const {loginStatus} = this.props;
        const {ordertoken} = this.search;
        const { accessToken } = loginStatus;
         // 如果已有ordertoken，即为支付回调 ·微信支付回调无论成败均是当前页·
         if (ordertoken && !!accessToken) {
            this.waitingTimer = window.setInterval(async () => {
                let paystate = await this.checkOrderState(ordertoken);
                // 待支付状态
                if (paystate === 0) {
                    // 显示倒计时10秒
                    let { waiting, waitingCount } = this.state;
                    if (waitingCount === 1) {
                        this.handleJumpPayResult(false);
                    }
                    this.setState({
                        waiting: true,
                        waitingCount: waiting ? waitingCount - 1 : 10,
                    });
                } else {
                    window.clearInterval(this.waitingTimer);
                    this.handleJumpPayResult(paystate === 3, ordertoken);
                }
            }, 1000);
        }
    }

    componentWillUnmount() {
        this.waitingTimer && window.clearInterval(this.waitingTimer);
    }


    checkOrderState = async (ordertoken: string) => {
        try {
            let data: any = await queryOrderDetailByOrderToken({ order_token: ordertoken });
            // 获取信息成功
            if (!data.status && data.result) {
                return data.result.payState;
            } else {
                return -1;
            }
        } catch (error) {
            console.log(error);
            return -1;
        }
    };
    

    handleJumpPayResult(flag: boolean, orderToken?: string) {
        // 当前订单已完成
        if (flag) {
            Toast.success('支付成功', 3, undefined, false);
            this.props.history.replace(`/success/${orderToken}?${qs.stringify(this.search)}`);
        } else {
            Toast.fail('支付失败', 3, undefined, false);
            this.props.history.replace(`/orderlist`);
        }
    }
    
    
    render() {
        let { waiting,waitingCount } = this.state;

        return (
            <Modal
                visible={waiting}
                transparent
                maskClosable={false}
                onClose={() => this.setState({ waiting: false })}
                title="等待支付结果"
            >
                <Waiting count={waitingCount} />
            </Modal>
        );
    }
}

export default createForm()(connect(withRouter(OrderPayWaiting)));